module.exports = __webpack_public_path__ + "img/75_harbourbridge.75d97d95.jpg";